import React from "react";
import { IMember } from "../../types/interfaces/IMember";
import { IMemberAddress } from "../../types/interfaces/IMemberAddress";
import { CardContent, Typography} from "@mui/material";
import {DirectoryResource} from '../../constants/DirectoryResource'


/**
 * ContactInformationCard Component
 * 
 * This component creates a card for displaying the contact information of a member.
 * It displays the address, city, state, zip code, country, phone number.
 * 
 * Props:
 * - member: An object of type IMember containing the member's information.
 * 
 * Example usage:
 * ```tsx
 * <ContactInformationCard member={member} />
 * ```
 * 
 * @param {IMember} member - The member object containing the contact information.
 * @returns {JSX.Element} A card displaying the member's contact information.
 */
export default function ContactInformationCard({member}: { member: IMember }) {
    let addresses: IMemberAddress[] | null = member.Addresses !== null && member.Addresses !== undefined ? member.Addresses : null;

    return (
        <>
            <React.Fragment>
                <CardContent>
                    <Typography sx={{fontSize: "0.8em", fontWeight: "bold"}}>{DirectoryResource.contact_lbl}:</Typography>
                    {addresses && addresses.length > 0 && addresses.map((address, index) => (
                        <React.Fragment key={index}>
                            {index > 0 && <br />}
                            {address.AddressLine1 && (
                                <Typography sx={{ fontSize: "0.8em", margin: "0, auto" }} key={'adr1_' + index}>{address.AddressLine1}</Typography>
                            )}
                            {address.AddressLine2 && (
                                <Typography sx={{ fontSize: "0.8em", margin: "0, auto" }} key={'adr2_' + index} display="block">{address.AddressLine2}</Typography>
                            )}
                            {(address.City || address.State || address.Zip) && (
                                <Typography sx={{ fontSize: "0.8em", margin: "0, auto" }} key={'cty_' + index} display="block">{address.City}{address.City && (address.State || address.Zip) ? ',' : ''} {address.State} {address.Zip}</Typography>
                            )}
                            {address.Country && (
                                <Typography sx={{ fontSize: "0.8em", margin: "0, auto" }} key={'cnty_' + index} display="block">{address.Country}</Typography>
                            )}
                        </React.Fragment>
                    ))}
                    {member.Phone && (
                        <Typography sx={{ fontSize: "0.8em", margin: "0, auto" }} key={'phn'} display="block">{member.Phone}</Typography>
                    )}
                    {member.Email && (
                        <Typography sx={{ fontSize: "0.8em", margin: "0, auto" }} key={'eml'} display="block">{member.Email}</Typography>
                    )}
                    {/* {member.website && <div><Typography sx={{fontSize: "0.8em", margin: "0, auto"}}>{DirectoryResource.website_lbl}: {member.website}</Typography></div>} */}
                </CardContent>
            </React.Fragment>
        </>
    );
}